<template>

<div>
  <div>
    <h2> Device: {{device}} </h2>
    <ul class="tracking-detail">
      <li> Desde : <span @click="showLatLng">{{from}}</span></li>
      <li> Hasta : San Antonio</li>
      <li> Tiempo recorrido: {{timeRun}}</li>
      <li> Rastreando...</li>
    </ul>
  </div>
    
  <div class="wrap-timeline">
    <span class="start">
    </span>
    <input type="range" min="0" max="100" step="0" :class="theme" v-model="step">
    <span class="end">
    </span>
  </div>
  <button @click="moveBack">  Atras   </button>
  <button @click="moveFoward"> Adelante </button>
  <button @click="showAlert">Finalizar</button>
  <button @click="changeColor('red-theme')">Evento</button>  
  <p>Trace is: {{ points[step] }} / {{ step }}</p>
  
</div>
</template>

<script>
import io  from "socket.io-client";
import moment  from 'moment';

export default {
  name: 'TimeLine',
  data () {
    return {
      id: 1,
      device: null,
      timeRun: 1,
      from: '12 de octubre',
      theme: 'blue-theme',
      connection: null,
      step: 0,
      points: [
        {name: '0', coordinates: [6.308153790347192,-75.57690918445587]},
        // {name: '1', coordinates: [6.308153790347192,-75.57690918445587]},
        // {name: '2', coordinates: [6.3079618405348725,-75.57669192552567]},
        // {name: '3', coordinates: [6.307601934445178,-75.57665437459946]},
        // {name: '4', coordinates: [6.307298013552616,-75.57664096355438]},
        // {name: '5', coordinates: [6.306868791637653,-75.57661682367325]},
        // {name: '6', coordinates: [6.30644756730106,-75.57662218809128]},
        // {name: '7', coordinates: [6.305797068286125,-75.5768072605133]},
        // {name: '8', coordinates: [6.305317191440547,-75.5770218372345]},
        // {name: '9', coordinates: [6.304794658370292,-75.57756900787354]},
        // {name: '10', coordinates: [6.3042614608170755,-75.57814836502075]},
        // {name: '11', coordinates: [6.303920214095343,-75.578373670578]},
        // {name: '12', coordinates: [6.303685606843898,-75.5785346031189]},
        // {name: '13', coordinates: [6.303301703839921,-75.57860970497131]},
        // {name: '14', coordinates: [6.302917800551806,-75.57865262031555]},
        // {name: '15', coordinates: [6.3022459691139545,-75.57857751846313]}
      ]
    }
  },

  created: function () {
    var me = this
    me.id =  new URL(location.href).searchParams.get('id')
    me.device =  new URL(location.href).searchParams.get('device')
    me.timeRun =  moment(new URL(location.href).searchParams.get('start')
, "YYYYMMDD").fromNow() 
//    const  connection =  io("ws://localhost:9000/tracking") 

    const  connection =  io("https://api.guard-dog.net/tracking")

    connection.on('@onNewPositionDevice', function (data) {
      console.log('new position for', data);
      if (String(data.device) === String(me.device)) {
        me.points.push({name: data})
        me.moveTo(Number(data.timeline))
      }
      // me.moveFoward()
      // if (data.status) {
      //   me.changeColor('red-theme')
      // }
      // if (err)  location.reload()
    })
  },

  // props: {
  // },

  methods: {
    showAlert() {
      // Use sweetalert2
      this.$swal('Este Trayecto ha Finalizado!');
    },
    moveFoward () {
      this.step += 1
    },

    showLatLng () {
      this.from = "1.68686, -1.677388"
    },

    changeColor(color) {
      this.theme = color    
    },

    moveBack () {
      this.step -= 1
    },

    moveTo (step) {
      this.step = Math.abs(step)
    }
  },

  mounted() {
    // const timeline = this.$refs.timeline
    // timeline.style.setProperty('--timelineTheme', this.timelineTheme)
    // timeline.style.setProperty('--timelineBg', this.timelineBg)
  }
}
</script>

<style scoped>
.blue-theme {
  overflow: hidden;
  width: 1000px;
  -webkit-appearance: none;
  background: navy;
}

.red-theme {
  overflow: hidden;
  width: 1000px;
  -webkit-appearance: none;
  background: red;
}

.tracking-detail {
  background: none;
}

.tracking-detail > li {
  list-style: none;
}
.wrap-timeline {
  width: 100%;
  height: 100px;
  /* background: red; */
  display: block;
}


.end {
  width: 80px; height: 80px;
  display: block;
  background-image: url('../assets/end.png');
  background-size: cover; 
  background-repeat: no-repeat;
  float: right;
  margin-top: -20px;
}

.start {
  width: 80px; height: 80px;
  display: block;
  background-image: url('../assets/start.png');
  background-size: cover;
  background-repeat: no-repeat;
  float: left;
  margin-top: -20px;
}

</style>
